import React from "react";
import "./FlowSteps.css";

const PAYMENT_STEP = {
  title: "Le paiement",
  text: "Vous réglez en toute sécurité par Orange Money ou MTN Mobile Money.",
};

const COMPANY_STEP = {
  title: "Votre entreprise",
  text: "Choisissez l'une de vos entreprises ou enregistrez-en une en quelques minutes.",
};

// "How it works" steps shown on the country step of each flow
const FLOW_STEPS = {
  creation: [
    {
      title: "Vos informations",
      text: "Type d'entreprise, dirigeant, nom : quelques questions suffisent.",
    },
    {
      title: "Vos documents",
      text: "Vous déposez les pièces demandées directement en ligne.",
    },
    PAYMENT_STEP,
    {
      title: "Le suivi",
      text: "Nos équipes traitent votre dossier et vous tiennent informé jusqu'à la remise de vos documents officiels.",
    },
  ],
  domiciliation: [
    COMPANY_STEP,
    {
      title: "Votre formule",
      text: "Mensuelle ou annuelle, avec les services utiles en option.",
    },
    PAYMENT_STEP,
    {
      title: "Votre domiciliation",
      text: "Nous activons votre domiciliation et vous remettons votre attestation.",
    },
  ],
  admin: [
    COMPANY_STEP,
    {
      title: "Votre formule",
      text: "Mensuelle ou annuelle, selon le chiffre d'affaires de votre entreprise.",
    },
    PAYMENT_STEP,
    {
      title: "La prise en charge",
      text: "Nos équipes prennent en charge vos déclarations dès l'activation de votre abonnement.",
    },
  ],
  juridique: [
    COMPANY_STEP,
    {
      title: "Votre formule",
      text: "Mensuelle ou annuelle, avec les services utiles en option.",
    },
    PAYMENT_STEP,
    {
      title: "L'accompagnement",
      text: "Nos juristes vous accompagnent dès l'activation de votre abonnement.",
    },
  ],
  management: [
    COMPANY_STEP,
    {
      title: "Vos modules",
      text: "Facturation, ressources humaines, relation client : vous ne payez que ce que vous activez.",
    },
    PAYMENT_STEP,
    {
      title: "Vos accès",
      text: "Nous configurons votre ERP en ligne et vous transmettons vos accès.",
    },
  ],
};

function FlowSteps({ flow }) {
  const steps = FLOW_STEPS[flow];

  if (!steps) return null;

  return (
    <section className="flow-steps" aria-labelledby="flow-steps-title">
      <div className="container">
        <h2 id="flow-steps-title" className="flow-steps-title">
          Comment ça marche ?
        </h2>
        <ol className="flow-steps-list">
          {steps.map((step, index) => (
            <li key={step.title} className="flow-step">
              <span className="flow-step-number" aria-hidden="true">
                {index + 1}
              </span>
              <strong>{step.title}</strong>
              <span>{step.text}</span>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default FlowSteps;
